import React, { Component, Fragment } from "react";
import { camelCase } from "lodash";
import * as actionTypes from "../../../store/Actions/actions";
import { connect } from "react-redux";
import "./Layout.scss";
//import Templates from "./Templates/Templates";
import * as UTILS from "../../../utils/Utils";

import { track } from "@amplitude/analytics-browser";

let htmlDATA = "";
let filesList = null;
let filesArray = null;
const regex = /\d+/g;
const removeChar = /[a-z]/g;
class Layout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      templates: false,
      blocks: false,
      html: false,
      dragEntered: false,

      files: "",
      htmlLoaded: false,
      filesAdded: null,
      fileLoaded: "",
      clickedBtn: false,
    };
  }

  componentDidMount() {
    this.setState({
      clicked: false,
    });
  }
  componentDidUpdate = (prevState) => {
    if (prevState.addBlockFlag !== this.props.addBlockFlag) {
      this.setState({
        blocks: this.props.addBlockFlag ? true : false,
      });
    }
  };
  dragEntered = () => {
    this.setState((prevState) => ({
      dragEntered: !prevState.dragEntered,
    }));
  };
  removeFile = (index) => {
    filesArray = filesArray.filter((item, ind) => {
      return ind !== index;
    });
  };
  dragLeave = () => {
    this.setState({
      dragEntered: false,
    });
  };
  sortingFiles = (e) => {
    const SortedFields = UTILS.applyDrag(filesArray, e);
    filesArray = SortedFields;
  };
  getVimeoId = (url) => {
    var match = /vimeo.*\/(\d+)/i.exec(url);
    if (match) {
      return match[1];
    }
  };
  camelizeKeys = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map((v) => this.camelizeKeys(v));
    } else if (obj !== null && obj.constructor === Object) {
      return Object.keys(obj).reduce(
        (result, key) => ({
          ...result,
          [camelCase(key)]: this.camelizeKeys(obj[key]),
        }),
        {}
      );
    }
    return obj;
  };
  //Color Palette

  render() {
    return (
      <div className="layoutWrapper">
        <div
          onClick={(e) => {
            e.preventDefault;
            e.stopPropagation();
            this.props.closeTool();
          }}
          className="overlayLayout"
        ></div>
        <div className="layoutMenusMain">
          <ul>
            <li
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                track("Template Option Selected", {
                  entryPoint: "Navigation Bar",
                });
                this.props.setToolTemplates();
              }}
              className="template"
            >
              Templates
            </li>

            <li
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                track("Blocks Option Selected", {
                  entryPoint: "Navigation Bar",
                });

                this.props.setToolBlocks();
              }}
              className="block"
            >
              Blocks
            </li>
            <li
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                track("Icons Option Selected", {
                  entryPoint: "Navigation Bar",
                });
                this.props.setToolIcon();
              }}
              className="icon"
            >
              Icons
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    glblClrs: state.present.colorsGlobal,
    preset: state.present.preset,
    layout: state.present.layout,
    containerBg: state.present.containerBgColor,
    containerWidth: state.present.containerWidth,
    pixel: state.present.pixel,
    percentage: state.present.percentage,
    imagesGlobal: state.present.imagesGlobal,
    bgImage: state.present.bgImage,
    bgImageId: state.present.bgImageId,
    bgImageIndex: state.present.bgImageIndex,
    layoutTitle: state.present.layoutTitle,
    selectedFont: state.present.selectedFont,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    pushGlobalColorArray: (colorGlobal) =>
      dispatch(actionTypes.global_colors(colorGlobal)),
    pushGlobalColorPreset: (presetColor) =>
      dispatch(actionTypes.preset(presetColor)),
    pushBgColor: (color) => dispatch(actionTypes.add_bg(color)),
    pushSelectedFont: (font) => dispatch(actionTypes.add_font(font)),
    pushContainerWidth: (width) => dispatch(actionTypes.container_width(width)),
    pushPixel: (pixelVal) => dispatch(actionTypes.pixel(pixelVal)),
    pushPercentage: (percentageVal) =>
      dispatch(actionTypes.percentage(percentageVal)),
    pushBGimage: (image, id) => dispatch(actionTypes.bg_image(image, id)),
    pushBGImages: (images) => dispatch(actionTypes.bg_images(images)),
    pushBGIndex: (index) => dispatch(actionTypes.bg_image_index(index)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
